import { type DateFnsLocale, dateFnsLocales } from "@mapmycustomers/shared/util/dateFnsLocales";

export { type DateFnsLocale, dateFnsLocales };

export type Listener = (locale: DateFnsLocale) => void;

// unlike momentjs, date-fns has no global locale, so we use this class to store its value
export class DateFnsLocaleService {
  private _locale: DateFnsLocale = dateFnsLocales.enUS;
  private _listeners: Listener[] = [];

  get locale(): DateFnsLocale {
    return this._locale;
  }

  set locale(locale: DateFnsLocale) {
    this._locale = locale;
    this._listeners.forEach((listener) => listener(locale));
  }

  addChangeListener(listener: Listener) {
    this._listeners.push(listener);
  }

  removeChangeListener(listener: Listener) {
    this._listeners = this._listeners.filter(
      (registeredListener) => registeredListener !== listener
    );
  }
}

const dateFnsLocaleService = new DateFnsLocaleService();

export default dateFnsLocaleService;
